import styled from '@emotion/styled'
import { DEFAULT_THEME_COLORS } from 'css/theme'
import { HyperlinkConfig } from 'modules/config/state/config-types'
import FAQDrawerOpener from 'modules/faq/components/faq-drawer-opener'
import { Hyperlink } from 'modules/hyperlink/hyperlinkComponent'

interface TwoColumnStepLayoutFAQToggleProps {
  hasContentPanel: boolean
  hyperlink?: HyperlinkConfig
}

export const TwoColumnStepLayoutFAQToggle = ({
  hasContentPanel,
  hyperlink,
}: TwoColumnStepLayoutFAQToggleProps) => (
  <Wrapper hideOnDesktop={hasContentPanel}>
    <FAQDrawerOpener textColor={DEFAULT_THEME_COLORS['--theme-color--neutral-10']} />
    <Hyperlink
      url={hyperlink?.url}
      text={hyperlink?.text}
      isEnabled={!!hyperlink?.isEnabled}
      textColor={DEFAULT_THEME_COLORS['--theme-color--neutral-10']}
    />
  </Wrapper>
)

const Wrapper = styled.div<{ hideOnDesktop: boolean }>`
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 784px) {
    display: ${({ hideOnDesktop }) => (hideOnDesktop ? 'none' : 'flex')};
  }
`
